import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';

export default {
  mixins: [apiUrlPrefix],
  data() {
    return {
      formLoading: false,
    };
  },
  methods: {
    // folders CRUD
    getFolder(folderObj, orientation) {
      this.formLoading = true;
      let params = {};
      if (folderObj && folderObj.id) {
        params = {
          directory: folderObj.id,
        };
      }
      if (typeof orientation !== 'undefined') {
        params.orientation = orientation;
      }
      const deferred = new Promise((resolve, reject) => {
        axios.get(`${apiUrlPrefix}media`, { params }).then((r) => {
          resolve(r.data.directory[0]);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Failed to fetch the folder: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    deleteFolder(folderObj) {
      const uid = folderObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show-confirmation', {
          title: folderObj.name,
          body: 'Delete the folder permanently?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.delete(`${apiUrlPrefix}media/directory`, { params: { id: uid } })
              .then(() => {
                this.$root.$emit('notification-add', { content: 'Folder deleted.' });
                resolve();
              })
              .catch((r) => {
                const errorMessage = this.handleFormErrors(r.response.data);
                this.$root.$emit('notification-add', {
                  content: `Unable to delete the folder: ${errorMessage}`,
                  variant: 'danger',
                  ttl: 10000,
                });
                reject(errorMessage);
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    updateFolder(folderObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.put(`${apiUrlPrefix}media/directory`, { ...folderObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'Folder updated.' });
          resolve(r.data.directory);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Failed to update the folder: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createFolder(folderObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}media/directory`, { ...folderObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'Folder created.' });
          resolve(r.data.directory);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Unable to create a folder: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    // files CRUD
    getFile(fileObj) {
      const uid = fileObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.formLoading = true;
        axios.get(`${apiUrlPrefix}media/file/${uid}`)
          .then((r) => {
            resolve(r.data.file);
          })
          .catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `Unable to fetch the file: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          })
          .finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    getFilePlaylists(fileObj) {
      const uid = fileObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.formLoading = true;
        axios.get(`${apiUrlPrefix}media/file/${uid}/playlists`)
          .then((r) => {
            resolve(r.data);
          })
          .catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `Unable to fetch the file: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          })
          .finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    deleteFile(fileObj) {
      const uid = fileObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show-confirmation', {
          title: fileObj.name,
          body: 'Delete the file permanently?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.delete(`${apiUrlPrefix}media/file/${uid}`)
              .then(() => {
                this.$root.$emit('notification-add', { content: 'File deleted.' });
                resolve();
              })
              .catch((r) => {
                const errorMessage = this.handleFormErrors(r.response.data);
                this.$root.$emit('notification-add', {
                  content: `Unable to delete the file: ${errorMessage}`,
                  variant: 'danger',
                  ttl: 10000,
                });
                reject(errorMessage);
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    updateFile(fileObj, suppressNotification = false) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        this.formLoading = true;
        axios.put(`${apiUrlPrefix}media/file`, { ...fileObj }).then((r) => {
          if (!suppressNotification) {
            this.$root.$emit('notification-add', { content: 'File updated.' });
          }
          resolve(r.data.file);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Failed to update the file: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    changeFile(fileObj) {
      const uid = fileObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show-confirmation', {
          title: fileObj.name,
          body: 'Selector for a slide type?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.delete(`${apiUrlPrefix}media/file/${uid}`)
              .then(() => {
                this.$root.$emit('notification-add', { content: 'File deleted.' });
                resolve();
              })
              .catch((r) => {
                const errorMessage = this.handleFormErrors(r.response.data);
                this.$root.$emit('notification-add', {
                  content: `Unable to delete the file: ${errorMessage}`,
                  variant: 'danger',
                  ttl: 10000,
                });
                reject(errorMessage);
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    createFile(fileObj, folderObj, formFile, type = 'image', replace = null) {
      this.formLoading = true;
      // creat formdata bla bla bla
      const formData = new FormData();
      formData.append('file', formFile);
      formData.append('name', fileObj.name);
      formData.append('directory_id', folderObj.id);
      if (replace) {
        formData.append('replace', replace.id);
      }
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}media/file/${type}`, formData,
          { headers: { 'Content-Type': 'multipart/form-data' } })
          .then((r) => {
            this.$root.$emit('notification-add', { content: 'File uploaded.' });
            resolve(r.data.file);
            // this.$router.push({ name: 'showUser', params: { id: r.data.user.id } });
          }).catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `File ${fileObj.name} failed to upload: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createUrl(fileObj, folderObj, url, replace) {
      this.formLoading = true;
      // creat formdata bla bla bla
      const formData = new FormData();
      formData.append('url', url);
      formData.append('name', fileObj.name);
      formData.append('directory_id', folderObj.id);
      if (replace) {
        formData.append('replace', replace.id);
      }
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}media/file/url`, formData,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          .then((r) => {
            this.$root.$emit('notification-add', { content: r.data.message });
            resolve(r.data.file);
            // this.$router.push({ name: 'showUser', params: { id: r.data.user.id } });
          }).catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `URL ${fileObj.name} failed to save: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createURLProxy() {
      // save current dir reference for background upload as user might navigate away
      const currentDirRef = this.currentDirectory || this.dir;
      const fileToReplace = this.file;
      this.$root.$emit('modal-show-upload-url', {
        title: 'Set the URL',
        body: 'Enter the url',
        cbConfirm: (url) => {
          const urlPromise = this.createUrl({ name: url }, currentDirRef, url, fileToReplace);
          this.$root.$emit('notification-add', {
            content: `URL ${url} saving...`,
            variant: 'info',
            ttl: Infinity,
            promise: urlPromise,
          });
          // handle the promise
          urlPromise.then((fileInfo) => {
            if (fileToReplace) {
              const fileToUpdateIndex = currentDirRef.files.findIndex(f => f.id === fileToReplace.id);
              // currentDirRef.files.replace;
              currentDirRef.files.splice(fileToUpdateIndex, 1, fileInfo);
              return;
            }
            currentDirRef.files.push(fileInfo);
            // if (this.currentDirectory && currentDirRef && currentDirRef.id === this.currentDirectory.id) { currentDirRef.files.push(fileInfo); }
          }).catch(() => { });
        },
        confirmText: 'Save',
        cancelText: 'Cancel',
      });
      if (this.hideModal) this.hideModal();
    },
    moveToUnusedFolder(fileIdsArray) {
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show-confirmation', {
          title: `Move ${fileIdsArray.length} files?`,
          body: 'Move the selected files?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.post(`${apiUrlPrefix}media/files/unused`, {ids: fileIdsArray})
              .then(() => {
                this.$root.$emit('notification-add', { content: 'Files moved to the Unused files folder.' });
                resolve();
              })
              .catch(() => {
                this.$root.$emit('notification-add', {
                  content: 'Unable to move the files',
                  variant: 'danger',
                  ttl: 10000,
                });
                reject();
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Move to Unused',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
  },
};
